import axios from 'axios';
import qs from 'qs';
import CryptoJS from 'crypto-js';
import md5 from 'js-md5';

const uri =  window.rootConfig.API_URL

var RemoteSlashToken = function (value) {
  var newValue = '';
  if (value.indexOf('{') > -1) {
    newValue = value.substring(value.indexOf('{'), value.indexOf('}') + 1);
  }
  if (!newValue) {
    return '';
  } else {
    var _value = new Function('', 'return ' + newValue)();
    return _value.token;
  }
};
function getCookie(){
  var cookie = window.document.cookie;

  var userInfo = ""
  if(cookie.indexOf("userInfo")>-1){
    var userInfoEncode = JSON.parse(cookie.split("userInfo=")[1].split(";")[0]);
    userInfo = {}
    userInfo.userName = decodeURIComponent(userInfoEncode.userName)
    userInfo.useId = decodeURIComponent(userInfoEncode.useId)
    userInfo.phoneNumber = decodeURIComponent(userInfoEncode.phoneNumber)
    userInfo.email = decodeURIComponent(userInfoEncode.email)
    userInfo.iid = decodeURIComponent(userInfoEncode.iid)
    userInfo.firstName = decodeURIComponent(userInfoEncode.firstName)
    userInfo.givenName = decodeURIComponent(userInfoEncode.givenName)
    userInfo.lastName = decodeURIComponent(userInfoEncode.lastName)
    userInfo.phoneZone = decodeURIComponent(userInfoEncode.phoneZone)
    userInfo.token = decodeURIComponent(userInfoEncode.token)
  }
  userInfo = userInfo == ""?"":JSON.stringify(userInfo)
  return userInfo
}

getToken();
var defaultOpt;

function getToken() {
  var str = window.document.cookie;

  var token = RemoteSlashToken(str);

  // var token = token + 'o58newor89ld78';

  // var token = md5(token);

  // eslint-disable-next-line
  var expiration = localStorage.expiration || '';

  // eslint-disable-next-line
  var refreshToken = localStorage.refreshToken || '';

  // eslint-disable-next-line
  defaultOpt = {
    headers: {
      'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
      Authorization: token,
    },

    withCredentials: true,
  };
}

//国家区号
var mobilePrefix = null;
var zh_TW = zh_TW;

// 是否仍在有效期
function isEffective() {
  if (accessToken == '') {
    return false;
  }
  return expiration - new Date().getTime() > 0 ? true : false;
}

// 是否可以刷新
function isRefreshable() {
  if (refreshToken == '') {
    return false;
  }
  return new Date().getTime() - expiration < 1000 * 60 * 60 * 24 * 7 ?
    true :
    false;
}

function setCookie(
  c_useName,
  c_useId,
  c_phoneNumber,
  c_email,
  c_iid,
  c_firstName,
  c_givenName,
  c_lastName,
  c_phoneZone,
  c_token,
  exdays
) {
  var cookiemsg = {
    userName: encodeURIComponent(c_useName),
    useId: encodeURIComponent(c_useId),
    phoneNumber: encodeURIComponent(c_phoneNumber),
    email: encodeURIComponent(c_email),
    iid: encodeURIComponent(c_iid),
    firstName: encodeURIComponent(c_firstName),
    givenName: encodeURIComponent(c_givenName),
    lastName: encodeURIComponent(c_lastName),
    phoneZone: encodeURIComponent(c_phoneZone),
    token: encodeURIComponent(c_token),
  };
  //为了兼容safari浏览器
  // cookiemsg=encodeURIComponent(JSON.stringify(cookiemsg));

  var exdate = new Date();
  exdate.setTime(exdate.getTime() + exdays * 24 * 60 * 60 * 1000);

  //字符串拼接cookie
  window.document.cookie =
    'userInfo=' + JSON.stringify(cookiemsg) + ';path=/;expires=' + exdate.toGMTString();
}

function getPhone() {
  return userInfo == null ? '' : userInfo.phone;
}

function checkToken(api) {
  if (!api.includes('/secure/')) {
    return true;
  }
  if (isEffective()) {
    return true;
  }
  return false;
}

function setTokenAndLogin(obj) {
  setToken(obj);
  getUserInfo(obj);
}

function freshing() {
  return new Promise((resolve, reject) => {
    post('/api/app/v1/token/refresh', {
      refreshToken: refreshToken,
    }).then(function (response) {
      if (response.data.code != 0) {
        reject(response.data);
      }
      setToken(response.data.data);
      resolve();
    });
  });
}

function create(method, api, data) {
  // TODO 修复移动端逻辑
  if (!checkToken(api)) {
    Loading.service().close();
    //window.location.href = '#/login';
    return false;
  }
  let option = Object.assign({}, defaultOpt);
  option.method = method;
  option.url = uri + api;
  option.data = qs.stringify(data);
  return axios(option);
}

function get(api, data) {
  return create('get', api, data);
}

function post(api, data) {
  return create('post', api, data);
}

// 谷歌第三方登录公共方法
var auth2;
function attachSignin(element, lang, url, cb) {
  auth2.attachClickHandler(
    element, {},
    function (googleUser) {
      // var id_token = googleUser.getAuthResponse().id_token;
      var profile = googleUser.getBasicProfile()
      var userJson = {
        id: profile.getId(),
        name: profile.getName(),
        email: profile.getEmail(),
      }
      userJson = Encrypt(JSON.stringify(userJson));

      post(url, {
        language: lang,
        // accessToken: id_token,
        userJson: userJson
      }).then((response) => {
        if (response.data.code == 200) {
          var fexlbo = response.data.data;
          var token = response.data.token;
          setCookie(
            fexlbo.userName,
            fexlbo.id,
            fexlbo.phoneNumber,
            fexlbo.email,
            fexlbo.iid,
            fexlbo.firstName,
            fexlbo.givenName,
            fexlbo.lastName,
            fexlbo.phoneZone,
            token,
            7
          );
          getToken();
          cb();
        }
      });
    },
    function (error) {}
  );
}

function startApp(id, lang, url, cb) {
  gapi.load('auth2', function () {
  auth2 = gapi.auth2.init({
      client_id: '320970774491-04q5hfkh5ceaavllm4qjj7gqrfds7ijc', //正式
      // client_id: '225201694336-ffppo2eo1a7dl97b2mf801ggadqthhoj', // 测试
      cookiepolicy: 'single_host_origin',
      scope: 'profile', //可以请求除了默认的'profile' and 'email'之外的数据
    });
    attachSignin(document.getElementById(id), lang, url, cb);
  });
}

// facebook第三方登录
function statusChangeCallback(response, lang, cb) {
  if (response.status === 'connected') {
    //登陆状态已连接
    getUserInfo(lang, cb);
  } else if (response.status === 'not_authorized') {
    //未经授权
    console.log('facebook未经授权');
  } else {
    console.log('不是登陆到Facebook;不知道是否授权');
  }
}

// 检验登录状态
function checkLoginState(lang, cb) {
  FB.getLoginStatus(function (response) {
    statusChangeCallback(response, lang, cb);
  });
}

function login(lang, cb) {
  FB.login(
    function (response) {
      if (response.authResponse) {
        checkLoginState(lang, cb);
      } else {
      }
    }, {
      scope: '',
      return_scopes: true,
    }
  );
}
//获取用户信息
function getUserInfo(lang, cb) {
  FB.api('/me', function (response) {
    var userJson = {
      name: response.name,
      id: response.id,
    };
    userJson = Encrypt(JSON.stringify(userJson));
    //把用户信息交给后台
    var data = {
      language: lang,
      userJson: userJson,
    };
    post('/user/facebookLogin', data).then((res) => {
      if (res.data.code == 200) {
        var fexlbo = res.data.data;
        var token = res.data.token;
        setCookie(
          fexlbo.userName,
          fexlbo.id,
          fexlbo.phoneNumber,
          fexlbo.email,
          fexlbo.iid,
          fexlbo.firstName,
          fexlbo.givenName,
          fexlbo.lastName,
          fexlbo.phoneZone,
          token,
          7
        );
        getToken();
        cb();
      }
    });
  });
}
// facebook第三方登录结束


// 加密 & 解密
const key = CryptoJS.enc.Utf8.parse('asdfghjklzxcvbnm'); //十六位十六进制数作为密钥
const iv = ''; //十六位十六进制数作为密钥偏移量
//加密方法
function Encrypt(word) {
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); //返回的是base64格式的密文
}
//解密方法
function Decrypt(word) {
  var restoreBase64 = word.replace(/\-/g, '+').replace(/_/g, '/');
  var decrypted = CryptoJS.AES.decrypt(restoreBase64, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypted).toString();
}

export default {
  get: get,
  post: post,
  uri: uri,
  create: create,
  setTokenAndLogin: setTokenAndLogin,
  isEffective: isEffective,
  isRefreshable: isRefreshable,
  freshing: freshing,
  getPhone: getPhone,
  setCookie: setCookie,
  getToken: getToken,
  // getMobilePrefix: getMobilePrefix
  startApp: startApp,
  login: login,
  Decrypt: Decrypt,
  Encrypt: Encrypt,
  getCookie:getCookie,
};



// WEBPACK FOOTER //
// ./src/components/request.js